// src/utils/axiosInstance.js
import axios from "axios";
const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Use your API base URL from environment variables
  headers: {
    "Content-Type": "application/json",
  },
});

// Create a function to initialize the interceptor with the logout function
export const setupAxiosInterceptors = (logout) => {
  // Request interceptor to attach token
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = localStorage.getItem("authToken"); // Retrieve token from localStorage
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );

  // Response interceptor to handle errors globally
  axiosInstance.interceptors.response.use(
    (response) => response,
    (error) => {
      const message = error?.response?.data?.message;

      if (message === "Invalid token.") {
        logout(); // Trigger logout from AuthContext
        // Optionally, notify the app of the logout
       // window.dispatchEvent(new Event("soft-login"));
      }

      return Promise.reject(error);
    }
  );
};

export default axiosInstance;
